import React from "react";
import Carousel from "./carousel.js";
import ButtonOrang from "./ButtonOrang.js";
import { Link } from "react-router-dom";
import VideoComex from "./VideoComex.js";

export default function EventDetailContent({ evento }) {
  if (!evento) return null;
  const apiUrl = process.env.REACT_APP_STRAPI_URL;

  return (
    <section
      data-testid="event-detail-content"
      className="relative bg-sidom-light dark:bg-sidom-blue pt-40 md:pb-24 pb-16"
    >
      <div className="relative ">
        <div className="container relative ">
          {/* Botón Atrás */}
          <div className="mb-2 flex justify-start">
            <div className=" ">
              <Link
                to="/sidom-eventos"
                className="hover:text-sidom-orange font-bold"
              >
                <i className="mdi mdi-arrow-left align-middle"></i> Volver
              </Link>
            </div>
          </div>
          <div>
            <div className="md:flex text-left ">
              <div className="lg:w-3/5 mb-[60px]">
                <h1 className=" text-4xl md:leading-normal leading-normal font-medium">
                  {evento.titulo}
                </h1>
                <div className="flex mt-5">
                  <span className="font-medium">
                    <i className="mdi mdi-calendar-blank-outline me-2"></i>
                    {evento.fecha_y_hora
                      ? evento.fecha_y_hora.slice(0, 10)
                      : "Sin fecha"}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex justify-start items-start text-left">
              <div className="w-full ">
                <div className="relative  ">
                  {evento?.imagen && (
                    <img
                      src={`${apiUrl}${
                        evento.imagen?.formats?.large?.url || evento.imagen?.url
                      }`}
                      className="rounded-xl w-[90%] md:w-[60%] max-h-[800px]  mx-auto shadow-md dark:shadow-gray-800 object-contain"
                      alt={evento.titulo}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="flex justify-start mt-[30px]">
              <div className=" text-left text-lg">
                {Array.isArray(evento.descripcion) &&
                  evento.descripcion.map((bloque, idx) => {
                    if (
                      bloque.type === "paragraph" &&
                      Array.isArray(bloque.children)
                    ) {
                      return (
                        <p
                          key={idx}
                          className="text-sidom-dark dark:text-sidom-light text-lg mt-4"
                        >
                          {bloque.children.map((child, i) => {
                            if (
                              child.type === "link" &&
                              child.url &&
                              Array.isArray(child.children)
                            ) {
                              return (
                                <a
                                  key={i}
                                  href={child.url}
                                  className="text-sidom-orange underline hover:text-sidom-orange/70"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {child.children.map((subChild, j) => {
                                    if (subChild.bold && subChild.italic) {
                                      return (
                                        <strong key={j}>
                                          <em>{subChild.text}</em>
                                        </strong>
                                      );
                                    } else if (subChild.bold) {
                                      return (
                                        <strong key={j}>{subChild.text}</strong>
                                      );
                                    } else if (subChild.italic) {
                                      return <em key={j}>{subChild.text}</em>;
                                    } else {
                                      return (
                                        <span key={j}>{subChild.text}</span>
                                      );
                                    }
                                  })}
                                </a>
                              );
                            }

                            if (child.bold && child.italic) {
                              return (
                                <strong key={i}>
                                  <em>{child.text}</em>
                                </strong>
                              );
                            } else if (child.bold) {
                              return <strong key={i}>{child.text}</strong>;
                            } else if (child.italic) {
                              return <em key={i}>{child.text}</em>;
                            } else {
                              return <span key={i}>{child.text}</span>;
                            }
                          })}
                        </p>
                      );
                    }
                    return null;
                  })}
              </div>
            </div>
          </div>
          <div
            data-testid="carousel-detail"
            className="mt-[70px] md:mt-[100px] lg:mt-[90px] mb-[70px] md:mb-[100px] lg:mb-[90px] "
          >
            {Array.isArray(evento.img) && evento.img.length > 0 && (
              <Carousel images={evento.img} />
            )}
          </div>
        </div>

        {evento?.video && (
          <div className="container mt-[70px] md:mt-[100px] lg:mt-[90px] mb-[70px] md:mb-[100px] lg:mb-[90px] ">
            <VideoComex
              key={evento?.video[0]?.id}
              video={evento?.video[0]?.url}
              controls={true}
              autoPlay={true}
              muted={true}
              loop={true}
            />
          </div>
        )}

        {evento.boton && (
          <div className="flex justify-center items-center ">
            <ButtonOrang
              text={evento.boton}
              link={
                evento.url?.startsWith("http") ? evento.url : `//${evento.url}`
              }
            />
          </div>
        )}
      </div>
    </section>
  );
}
